// 定义store对象
const loading = {
  state: {
    isLoading: false
  },
  actions: {

  },
  mutations: {
    setLoading (state, loading) {
      state.isLoading = loading
    }
  }
}

export default loading
